import React from 'react';
import {Box, Button, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import convertToCurrency from "../../utils/convertToCurrency";

const CampaignDetailTable = ({ classes, campaignData }) => {

    /**
     * @param name
     * @param choiceOfLaw
     * @returns {JSX.Element}
     * @constructor
     */
    const DetailBox = ({ name, choiceOfLaw, type = '', id}) => (
        <Box display={"flex"} flexDirection={"column"}>
            <Box style={{marginBottom: '5px'}}>
                {type === 'link' ? (
                    <>
                        <a
                            href="/#"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(`/info/servicers/${id}`)
                            }}>{name}</a>
                    </>
                ) : (
                    <>
                        {name}
                    </>
                )}
            </Box>
            <Box>
                <strong>Choice Of Law &ndash;</strong> {choiceOfLaw}
            </Box>
        </Box>
    );


    return (
        <Table className={classes.table} size="small">
            <TableHead>
                <TableRow>
                    <TableCell variant="head">Name</TableCell>
                    <TableCell variant="head">Customer Info</TableCell>
                    <TableCell variant="head">Portfolio</TableCell>
                    <TableCell variant="head">Servicer</TableCell>
                    <TableCell variant="head">Campaign Type</TableCell>
                    <TableCell variant="head">Price Point</TableCell>
                    <TableCell variant="head">Ping Tree Wait</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell variant="body">
                        <DetailBox
                            name={campaignData.name}
                            choiceOfLaw={campaignData.choiceOfLaw}
                        />
                    </TableCell>
                    <TableCell variant="body">
                        <strong>Name</strong> - {campaignData.customerCampaignName}
                        <br/>
                        <strong>ID</strong> - {campaignData.customerCampaignId}
                    </TableCell>
                    <TableCell variant="body">
                        <DetailBox
                            name={campaignData.portfolio.name}
                            choiceOfLaw={campaignData.portfolio.choiceOfLaw}
                        />
                    </TableCell>
                    <TableCell variant="body">
                        <DetailBox
                            name={campaignData.servicer.name}
                            id={campaignData.servicer.id}
                            choiceOfLaw={campaignData.servicer.choiceOfLaw}
                            type="link"
                        />
                    </TableCell>
                    <TableCell variant="body">{campaignData.type}</TableCell>
                    <TableCell variant="body">
                        <strong>Price</strong>: {convertToCurrency(campaignData.pricePoint)}
                        <br/>
                        <strong>Config Key</strong>: {campaignData.pricePointConfigKey}
                    </TableCell>
                    <TableCell variant="body">{campaignData.pingTreeWait}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default CampaignDetailTable;
